import { css } from '@emotion/css';
import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import colors from '@/theme/colors';

export const LoadingSpinner: React.FC = () => {
  const [liveMessage, setLiveMessage] = useState<string>('');

  useEffect(() => {
    setLiveMessage('Loading... Please wait.');
    const timeout = setTimeout(() => setLiveMessage(''), 1000);
    return () => clearTimeout(timeout);
  }, []);

  return (
    <div role="status" aria-live="polite" aria-atomic="true" className={styles.container}>
      <span aria-hidden="true">
        <CircularProgress style={{ color: colors.leaf }} />
      </span>
      <span className="sr-only">{liveMessage}</span>
    </div>
  );
};

const styles = {
  container: css`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
  `,
};
